export type ProtocolTheme = {
  label: string;
  icon: string;
  text: string;
  bg: string;
  border: string;
};

export const PROTOCOL_THEME: Record<string, ProtocolTheme> = {
  'Wi-Fi': { label: 'Wi-Fi', icon: '📶', text: '#4FC3F7', bg: 'rgba(79,195,247,0.15)', border: 'rgba(79,195,247,0.35)' },
  'RF 433.92': { label: '433', icon: '📡', text: '#90CAF9', bg: 'rgba(144,202,249,0.15)', border: 'rgba(144,202,249,0.35)' },
  'ZigBee 3.0': { label: 'ZigBee', icon: '🕸️', text: '#CE93D8', bg: 'rgba(206,147,216,0.15)', border: 'rgba(206,147,216,0.35)' },
  'Wi-Fi (MiHome)': { label: 'MiHome', icon: '📶', text: '#4FC3F7', bg: 'rgba(79,195,247,0.15)', border: 'rgba(79,195,247,0.35)' },
  'Wi-Fi (TUYA)': { label: 'TUYA', icon: '📲', text: '#29B6F6', bg: 'rgba(41,182,246,0.15)', border: 'rgba(41,182,246,0.35)' },
  'ZigBee': { label: 'ZigBee', icon: '🕸️', text: '#CE93D8', bg: 'rgba(206,147,216,0.15)', border: 'rgba(206,147,216,0.35)' },
  'Matter': { label: 'Matter', icon: '✨', text: '#A5D6A7', bg: 'rgba(165,214,167,0.15)', border: 'rgba(165,214,167,0.35)' },
  'RF': { label: 'RF-пульт', icon: '🎛️', text: '#90CAF9', bg: 'rgba(144,202,249,0.15)', border: 'rgba(144,202,249,0.35)' },
  'RS-485': { label: 'RS-485', icon: '🔗', text: '#81D4FA', bg: 'rgba(129,212,250,0.15)', border: 'rgba(129,212,250,0.35)' },
  'Фаза': { label: 'Фаза', icon: '〰️', text: '#FFE082', bg: 'rgba(255,224,130,0.12)', border: 'rgba(255,213,79,0.45)' },
  'Сухой контакт': { label: 'Сухой контакт', icon: '🔘', text: '#B0BEC5', bg: 'rgba(176,190,197,0.12)', border: 'rgba(176,190,197,0.35)' },
  'Пульт ДУ': { label: 'Пульт ДУ', icon: '🎛️', text: '#90CAF9', bg: 'rgba(144,202,249,0.12)', border: 'rgba(144,202,249,0.35)' },
  'FC': { label: 'FC', icon: '⚙️', text: '#80DEEA', bg: 'rgba(128,222,234,0.15)', border: 'rgba(128,222,234,0.35)' },
};
